import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import AppointmentTypeButtonContainer from '../../AppointmentTypeButton/AppointmentTypeButtonContainer.js';

const SingleAppointmentTypeList = (_param)=>{
    var { className , appointmentTypes , appointmentTypeIcons , appointmentTypeToolTips , appointmentGlobalLabels , onClick , onClickToolTip  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "appointmentTypes",
        "appointmentTypeIcons",
        "appointmentTypeToolTips",
        "appointmentGlobalLabels",
        "onClick",
        "onClickToolTip"
    ]);
    return /*#__PURE__*/ React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('appointment-type-list', className)
    }), appointmentTypes.map((appointmentType)=>/*#__PURE__*/ React.createElement("li", {
            className: "appointment-type-list__item",
            key: appointmentType.id
        }, appointmentType.isVisibleToCustomers && /*#__PURE__*/ React.createElement(AppointmentTypeButtonContainer, {
            icon: appointmentTypeIcons[appointmentType.id],
            appointmentType: appointmentType,
            toolTip: appointmentTypeToolTips[appointmentType.id],
            onClick: onClick,
            onClickToolTip: onClickToolTip,
            "data-t": appointmentGlobalLabels[appointmentType.id] || appointmentType.id
        }))
    ));
};

export { SingleAppointmentTypeList as default };
//# sourceMappingURL=SingleAppointmentTypeList.js.map
